// Export selectors
export const selectReportingHistory = (state) =>
  Array.isArray(state.licenseView.reportingHistory)
    ? null
    : state.licenseView.reportingHistory;
export const selectReportingHistoryInProgress = (state) =>
  state.licenseView.isGetReportingHistoryInProgress;
export const selectReportingHistorySuccess = (state) =>
  state.licenseView.isGetReportingHistorySuccess;
export const selectReportingHistoryErrorMsg = (state) =>
  state.licenseView.reportingHistoryErrorMsg;

export const selectPropertyContacts = (state) =>
  state.licenseView.propertyContacts;
export const selectPropertyContactsInProgress = (state) =>
  state.licenseView.isGetPropertyContactsInProgress;
export const selectPropertyContactsSuccess = (state) =>
  state.licenseView.isGetPropertyContactsSuccess;
export const selectPropertyContactsErrorMsg = (state) =>
  state.licenseView.propertyContactsErrorMsg;

export const selectPermitActionability = (state) =>
  state.licenseView.permitActionability;
export const selectPermitActionabilityInProgress = (state) =>
  state.licenseView.isGetPermitActionabilityInProgress;
export const selectPermitActionabilitySuccess = (state) =>
  state.licenseView.isGetPermitActionabilitySuccess;
export const selectPermitActionabilityErrorMsg = (state) =>
  state.licenseView.permitActionabilityErrorMsg;
